import Http from '../../common/services/Http';
import { VehicleMonthlyCostsDto } from './models/VehicleMonthlyCostsDto';
import { VehicleMonthlyCostsSearchCriteria } from './models/VehicleMonthlyCostsSearchCriteria';

export interface RecalculationStatus {
    isRunning: boolean;
    totalVehicles: number;
    processedVehicles: number;
    startedAt?: string;
    finishedAt?: string;
    error?: string;
}

class VehicleMonthlyCosts {

    public getMonthlyCostCounters(criteria: VehicleMonthlyCostsSearchCriteria) {
        return Http.get<VehicleMonthlyCostsDto[]>('vehicles/monthly-cost-counters', criteria);
    }
    
    public calculateMonthlyCosts(companyId?: string) {
        return Http.put('vehicles/calculate-monthly-costs', { companyId: companyId });
    }

    public calculateAllMonthlyCosts() {
        return Http.put('vehicles/calculate-all-monthly-costs', {});
    }

    public getRecalculationStatus(companyId: string) {
        return Http.get<RecalculationStatus>(`vehicles/calculate-monthly-costs/${companyId}/status`);
    }

    public getAllRecalculationStatus() {
        return Http.get<RecalculationStatus>('vehicles/calculate-all-monthly-costs/status');
    }
}

export default new VehicleMonthlyCosts();